import PropTypes from 'prop-types';

export default class CreateWishList extends React.Component {
  static propTypes = {
    accountInfo: PropTypes.object,
    updateWishListHandler: PropTypes.func,
    triggerLoader: PropTypes.func
  };

  static defaultProps = {
    triggerLoader: () => {}
  };

  constructor() {
    super();

    this.state = {
      showFetchError: false,
      fetchErrorBody: {}
    };
  }

  _clearCreateInput = () => {
    const el = $('input[name=wishListName]');

    el.val('');
  };
  _fetchErrorHandler = (response) => {
    if (!response.ok) {
      const errorBody = $.extend(true, {}, this.state.fetchErrorBody);

      errorBody.name = response.message;
      this.setState({ showFetchError: true, fetchErrorBody: errorBody });
      $('.sk-loader-admin').hide();
      $('.item-list').show();
    }
  };
  _saveNewWishList = () => {
    const wishListName = $('input[name=wishListName]').val();
    const requestBody = {
      wishListName: `${wishListName}`,
      userId: `${this.props.accountInfo.id}`,
      regionId: 10,
      csrfToken: window.beaches_app.page.csrfToken
    };

    if (wishListName !== '') {
      // $('.sk-loader-admin').show();
      this.props.triggerLoader(true);
      $('.error-empty').hide();
      $('.item-list').hide();

      $.ajax({
        url: '/wishlist/save/',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(requestBody)
      })
        .done((result) => {
          this._fetchErrorHandler(result);
          this.props.updateWishListHandler(result.data.saveWishListResult);
          this._clearCreateInput();
          this.props.triggerLoader();
          $('.item-list').show();
        })
        .fail((textStatus, errorThrown) => console.warn(errorThrown));
    } else {
      $('.error-empty').show();
      this.setState({showFetchError: false});
    }
  }

  render() {
    const {showFetchError, fetchErrorBody} = this.state;
    const {accountInfo} = this.props;

    return(
      <div className="xs-12 create-container">
        <label htmlFor="toggle-create" className="gold-label">
          <i className="chevron-sm right"/>
          Create a new wishlist
        </label>
        <input type="checkbox" id="toggle-create" className="hide"/>
        <div className="row create-content center-xs">
          <div className="control-wrapper xs-12 lg-7 create-input">
            <input type="text" name="wishListName" id="wishListName" placeholder="Name your Wishlist" maxLength="30" required />
          </div>
          <div className="xs-8 lg-3">
            <button className="form-submit-button" onClick={this._saveNewWishList}>create</button>
          </div>
        </div>
        <span className={ showFetchError ? 'xs-12 error-input' : 'hide' }>{ fetchErrorBody.name }</span>
        <span className="xs-12 error-empty">Enter a Wishlist Name.</span>
        <input type="hidden" value={`${accountInfo.id}`}/>
      </div>
    );
  }
}
